<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-03-04',
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : 'プリスタパック',
            id          : 'AM-105',
            rare        : 'KR',
            name        : 'スイートハニーブルーキラッとワンピ',
            imgUrl      : '/images/items/AM-105.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 1900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-106',
            rare        : 'KR',
            name        : 'スイートハニーブルーキラッとシューズ',
            imgUrl      : '/images/items/AM-106.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-107',
            rare        : 'KR',
            name        : 'スイートハニーブルーキラッとヘアアクセ',
            imgUrl      : '/images/items/AM-107.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'KR',
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-056',
            rare        : 'KR',
            name        : 'クールミラクル☆キラッツグループキラッとワンピ',
            imgUrl      : '/images/items/AM-056_28362.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 1900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-057',
            rare        : 'KR',
            name        : 'クールミラクル☆キラッツグループキラッとシューズ',
            imgUrl      : '/images/items/AM-057_28363.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-058',
            rare        : 'KR',
            name        : 'クールミラクル☆キラッツグループキラッとヘアアクセ',
            imgUrl      : '/images/items/AM-058_28364.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            // id          : 'P-027'
            collection  : 'プリスタパック',
            rare        : 'PR',
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-059',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトグリーンスカート',
            imgUrl      : '/images/items/AM-059_28306.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-060',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトグリーンシューズ',
            imgUrl      : '/images/items/AM-060.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-061',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトグリーンヘアアクセ',
            imgUrl      : '/images/items/AM-061.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-062',
            rare        : 'PR',
            name        : 'フラワープリンセスブルートップス',
            imgUrl      : '/images/items/AM-062.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-063',
            rare        : 'PR',
            name        : 'フラワープリンセスブルースカート',
            imgUrl      : '/images/items/AM-063.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-064',
            rare        : 'PR',
            name        : 'フラワープリンセスブルーシューズ',
            imgUrl      : '/images/items/AM-064.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-065',
            rare        : 'PR',
            name        : 'フラワープリンセスブルーヘアアクセ',
            imgUrl      : '/images/items/AM-065.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-066',
            rare        : 'PR',
            name        : 'スーパーサイリウムあろまアナザーワンピ',
            imgUrl      : '/images/items/AM-066.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 1610,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-067',
            rare        : 'PR',
            name        : 'スーパーサイリウムあろまアナザーシューズ',
            imgUrl      : '/images/items/AM-067.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-068',
            rare        : 'PR',
            name        : 'スーパーサイリウムあろまアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-068.png',
            kind        : 'アクセサリー',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'プリスタパック',
            id          : 'AM-069',
            rare        : 'SR',
            name        : 'ノーブルドールグリーントップス',
            imgUrl      : '/images/items/AM-069.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-070',
            rare        : 'SR',
            name        : 'ノーブルドールグリーンパンツ',
            imgUrl      : '/images/items/AM-070.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-071',
            rare        : 'SR',
            name        : 'ノーブルドールグリーンシューズ',
            imgUrl      : '/images/items/AM-071.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-072',
            rare        : 'SR',
            name        : 'ノーブルドールグリーンヘアアクセ',
            imgUrl      : '/images/items/AM-072.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'SR',
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-073',
            rare        : 'SR',
            name        : 'ノーブルドールラベンダーパンツ',
            imgUrl      : '/images/items/AM-073.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'SR',
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-074',
            rare        : 'SR',
            name        : 'ブリリアントプリンススカーレットサイリウムワンピ',
            imgUrl      : '/images/items/AM-074.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-075',
            rare        : 'SR',
            name        : 'ブリリアントプリンススカーレットサイリウムシューズ',
            imgUrl      : '/images/items/AM-075.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-076',
            rare        : 'SR',
            name        : 'ブリリアントプリンススカーレットサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-076.png',
            kind        : 'アクセサリー',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-077',
            rare        : 'SR',
            name        : 'ピュアプレミアムブロッサムウエディング',
            imgUrl      : '/images/items/AM-077.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-078',
            rare        : 'SR',
            name        : 'ピュアプレミアムブロッサムハイヒール',
            imgUrl      : '/images/items/AM-078.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-079',
            rare        : 'SR',
            name        : 'ピュアプレミアムブロッサムティアラ',
            imgUrl      : '/images/items/AM-079.png',
            kind        : 'アクセサリー',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'プリスタパック',
            id          : 'AM-080',
            rare        : 'R',
            name        : 'ポップコーンショップレッドトップス',
            imgUrl      : '/images/items/AM-080.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DW',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-081',
            rare        : 'R',
            name        : 'ポップコーンショップレッドパンツ',
            imgUrl      : '/images/items/AM-081.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-082',
            rare        : 'R',
            name        : 'ポップコーンショップレッドシューズ',
            imgUrl      : '/images/items/AM-082.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-083',
            rare        : 'R',
            name        : 'ポップコーンショップレッドヘアアクセ',
            imgUrl      : '/images/items/AM-083.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-084',
            rare        : 'R',
            name        : 'プリ×プリメイドパープルトップス',
            imgUrl      : '/images/items/AM-084.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-085',
            rare        : 'R',
            name        : 'プリ×プリメイドパープルスカート',
            imgUrl      : '/images/items/AM-085.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-086',
            rare        : 'R',
            name        : 'プリ×プリメイドパープルシューズ',
            imgUrl      : '/images/items/AM-086.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-087',
            rare        : 'R',
            name        : 'プリ×プリメイドパープルヘアアクセ',
            imgUrl      : '/images/items/AM-087.png',
            kind        : 'アクセサリー',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-088',
            rare        : 'R',
            name        : 'しんぴのシンフォニアドレス',
            imgUrl      : '/images/items/PAF02-05.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-089',
            rare        : 'R',
            name        : 'ゆめみるシンフォニアパンプス',
            imgUrl      : '/images/items/PAF02-06.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-090',
            rare        : 'R',
            name        : 'よろこびのシンフォニアカチューシャ',
            imgUrl      : '/images/items/PAF02-07.png',
            kind        : 'アクセサリー',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'プリスタパック',
            id          : 'AM-091',
            rare        : 'N',
            name        : 'ツートンカラーパターントップス',
            imgUrl      : '/images/items/AM-091.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-092',
            rare        : 'N',
            name        : 'ツートンカラーパターンスカート',
            imgUrl      : '/images/items/AM-092.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-093',
            rare        : 'N',
            name        : 'ツートンカラーパターンシューズ',
            imgUrl      : '/images/items/AM-093.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-094',
            rare        : 'N',
            name        : 'ツートンカラーパターンヘアアクセ',
            imgUrl      : '/images/items/AM-094.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-095',
            rare        : 'N',
            name        : 'スターダストブルーグラデワンピ',
            imgUrl      : '/images/items/AM-095.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-096',
            rare        : 'N',
            name        : 'スターダストブルーグラデシューズ',
            imgUrl      : '/images/items/AM-096.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-097',
            rare        : 'N',
            name        : 'スターダストブルーグラデヘアアクセ',
            imgUrl      : '/images/items/AM-097.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'N',
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-098',
            rare        : 'N',
            name        : 'トゥインクルスターかただしトップス',
            imgUrl      : '/images/items/AM-098.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-099',
            rare        : 'N',
            name        : 'トゥインクルスタースカート',
            imgUrl      : '/images/items/AM-099.png',
            kind        : 'スカート',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-100',
            rare        : 'N',
            name        : 'トゥインクルスターシューズ',
            imgUrl      : '/images/items/AM-100.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-101',
            rare        : 'N',
            name        : 'トゥインクルスターヘアアクセ',
            imgUrl      : '/images/items/AM-101.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリスタパック',
            id          : 'AM-102',
            rare        : 'N',
            name        : 'じょうねつのシンフォニアドレス',
            imgUrl      : '/images/items/PAF02-01.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-103',
            rare        : 'N',
            name        : 'はじまりのシンフォニアブーツ',
            imgUrl      : '/images/items/PAF02-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 400,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            id          : 'AM-104',
            rare        : 'N',
            name        : 'えいえんなるシンフォニアティアラ',
            imgUrl      : '/images/items/PAF02-03.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 400,
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリスタパック',
            rare        : 'N',
          }),
        ],
      }
    },

    computed: {
      itemsKR () {
        return _.where(this.items, {  rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col3>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <Status :date="date" :items="items" :showKR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
